import { Injectable, signal } from '@angular/core';

/**
 * 사이드바 「RP 서비스」 목록을 다시 읽으라는 신호. 목록(`GET /orgs/:orgId/services`)은 단체·팀을 바꿀 때만 다시 읽는 구조라, 사용 결정
 * 화면에서 서비스를 켜고 끄거나 순서를 바꿔도 단체를 전환하거나 새로고침하기 전까지는 사이드바가 낡아 있었다. 사용 결정 화면이 변경에 성공하면
 * `refresh()`를 부르고, 사이드바(`app.ts`)가 `version`이 바뀔 때 목록을 다시 읽는다.
 */
@Injectable({ providedIn: 'root' })
export class ServiceListRefreshService {
  /** 값 자체에는 의미가 없고 바뀌었다는 사실만 쓴다. */
  readonly version = signal(0);

  refresh(): void {
    this.version.update((v) => v + 1);
  }
}
